import {Vehicle} from './vehicle';
import {NamedItem} from './named-item';
import { BackendLocationModel } from './location.model';
import {Driver, DriverModel} from './driver.model';
import {VehicleModel} from './vehicle.model';
import {ObservationTypeGroup} from './observation-group';
import { ObservationModel } from './observation.model';

export class ObservationType implements NamedItem {

  group?: ObservationTypeGroup;

  constructor(public readonly id: number,
              public readonly title: string,
              public readonly mapLabel: string,
              public readonly observationTypeGroupId: number) {}

  static isStationaryAlert(type: ObservationType) {
    return type.title === 'Stationary Alert' || type.title === 'No Longer Stationary';
  }
}

export class Observation implements NamedItem {
  get title(): string {
    return this.vehicle.label;
  }

  constructor(public readonly id: number,
              public readonly created: Date,
              public observationType: ObservationType,
              public location: BackendLocationModel,
              public readonly shiftId?: number|null,
              public readonly vehicle?: Vehicle | VehicleModel | null,
              public readonly driver?: Driver | DriverModel | null,
              public readonly expiration?: Date,
              public readonly imageUrl?: string|null,
              public readonly comment?: string|null,
  ) {}

  static observationDateCompare(o1: Observation, o2: Observation): number {
    if (o1.expiration === null) {
      return 1;
    } else if (o2.expiration === null) {
      return -1;
    } else {
      // positive = o1.expiration is after o2.expiration
      // negative = o1.expiration is before o2.expiration
      return o1.expiration.getTime() - o2.expiration.getTime();
    }
  }

  static fromModel(
    model: ObservationModel,
    type: ObservationType,
    vehicle: VehicleModel | Vehicle | null,
    driver: DriverModel | Driver | null,
  ): Observation {
    const {id, location, timestamp, expiration, shiftId, imageUrl, comment} = model;
    return new Observation(
      id,
      new Date(timestamp),
      type,
      location,
      shiftId,
      vehicle,
      driver,
      expiration ? new Date(expiration) : null,
      imageUrl,
      comment,
    );
  }
}
